
// -------------------------------------------- Cookie utilities
function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

// --------------------------------------------

// -------------------------------------------- Black/white color switch
function hexToDec(hex) {
	return parseInt(hex, 16);
}

function hexToRGB(hexColor) {
	// WARNING: hex color code MUST always have 6 chars
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);

	if (result != null)
		return hexToDec(result[1]) + hexToDec(result[2]) + hexToDec(result[3]);
	else
		return 255 * 3;
}

function updateBodyColor(bgcolor) {
	document.body.setAttribute('style', 'background-color: ' + bgcolor);
	document.body.setAttribute('data-bgcolor', bgcolor)
}

// Applies the proper CSS class to the body to set foreground color
function checkPageColors() {
	let bodyColor = "ffffff"; // default body background color

	if (document.body.hasAttribute('data-bgcolor'))
		bodyColor = document.body.getAttribute('data-bgcolor').replace('#', '');
	else {
		if ( document.body.hasAttribute('style')
		&& (document.body.getAttribute('style').indexOf('background-color') >= 0)
		&& (document.body.getAttribute('style').indexOf('#') >= 0) ) {

				bodyColor = document.body.getAttribute('style').split('#')[1].replace(';', '');
		}
		else if (document.body.classList.contains('--bg-black'))
			bodyColor = "000000";
	}

	const threshold = (256 * 3 / 2) * 1.1;	// applied 1.1 correction factor to improve contrast
	let decimalValue = hexToRGB(bodyColor);

	document.body.classList.remove('--txt-black', '--txt-white');
	if (decimalValue >= threshold)
		document.body.classList.add('--txt-black');
	else
		document.body.classList.add('--txt-white');
}
// --------------------------------------------

// -------------------------------------------- General const and handlers

const desktopScreen = window.matchMedia("(min-width: 1025px)");
const tabletLandscape = window.matchMedia("(min-width: 992px) and (max-width: 1024px)");


document.addEventListener('DOMContentLoaded', function (evt) {

	if (document.body.classList.contains('--dynamic-color'))
		checkPageColors();

});

// -------------------------------------------- Background-color transition to the next page
document.addEventListener('click', function(e) {

	if (!e.target.closest('a[data-bgcolor]')) return;

	document.querySelector('html').setAttribute('style', 'background-color: ' + e.target.closest('a[data-bgcolor]').getAttribute('data-bgcolor') + ';');

});
